<template>
  <div class="box">
    <div class="content">
      <div class="left">
        <ul>
          <li @click="HomePage(0)">首页</li>
          <li @click="HomePage(1)">产品中心</li>
          <li @click="HomePage(2)">关于我们</li>
          <li @click="HomePage(3)">行业新闻</li>
          <li @click="HomePage(4)">合作伙伴</li>
        </ul>
        <ul>
          <li @click="Unit(1)">产品中心</li>
          <li @click="Unit(1)">大气专项</li>
          <li @click="Unit(2)">水专项</li>
          <li @click="Unit(3)">固废专项</li>
          <li @click="Unit(4)">指挥调度</li>
          <li @click="Unit(5)">智慧管网</li>
          <li @click="Unit(6)">电力专项</li>
        </ul>
        <ul>
          <li @click="AboutUs(1)">关于我们</li>
          <li @click="AboutUs(1)">关于公司</li>
          <!-- <li @click="AboutUs(2)">关于产品</li> -->
          <!-- <li @click="AboutUs(3)">资质荣誉</li> -->
        </ul>
        <ul>
          <li @click="Dynamic(1)">行业新闻</li>
          <li @click="Dynamic(1)">行业新闻</li>
          <!-- <li @click="Dynamic(2)">行业资讯</li> -->
          <!-- <li @click="Dynamic(3)">相关政策</li> -->
        </ul>
        <ul>
          <li @click="Training()">培训</li>
          <li @click="Training()">视频教学</li>
        </ul>
        <ul>
          <li @click="ContactUs(1)">市场合作</li>
          <li @click="ContactUs(1)">市场合作</li>
        </ul>
      </div>
      <div class="right">
        <div class="QRcode">
          <img src="../../assets/images/footer/QRcode (2).png" alt="" />
          <div style="margin-top: 10px">扫码联系我们</div>
        </div>
        <div class="way">
          <div class="tle">联系电话: 010-80251293, 18510508157</div>
          <div class="site">
            <!-- 地址: 北京市西红门兴创国际中心四期S座809-1室 <br />
            &nbsp; &nbsp; &nbsp; &nbsp; 武汉市经济技术开发区东合中心E座506室 -->
            <div style="white-space: nowrap">地址:</div>
            <div>
              <span>北京市西红门兴创国际中心四期S座809-1室</span> <br />
              <span>武汉市经济技术开发区东合中心E座506室</span>
            </div>
          </div>
          <div class="mailbox" style="white-space: nowrap">
            邮箱:fangwei@zhongzeyuhua.com
          </div>
        </div>
      </div>
    </div>
    <div class="base">
      <div class="deta">
        <div>
          Copyright © 2022,北京中泽宇华环境科技有限公司 &nbsp;&nbsp;
          京ICP备2022008852号-1
        </div>
        <!-- <div>技术支持:xxxxx</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",

  data() {
    return {
      is: null,
    };
  },

  created() {},

  mounted() {},

  methods: {
    // 首页
    HomePage(a) {
      // console.log("首页");
      let num = null;
      switch (a) {
        case 0:
          num = "zero";
          break;
        case 1:
          num = "one";
          break;
        case 2:
          num = "two";
          break;
        case 3:
          num = "three";
          break;
        case 4:
          num = "four";
          break;
      }
      this.$router.push({ path: "/home", query: { id: num } });
    },
    // 产品中心
    Unit(a) {
      // console.log("产品中心", a);
      let num = null;
      switch (a) {
        case 1:
          num = "one";
          break;
        case 2:
          num = "two";
          break;
        case 3:
          num = "three";
          break;
        case 4:
          num = "four";
          break;
        case 5:
          num = "five";
          break;
        case 6:
          num = "six";
          break;
      }
      this.$router.push({ path: "/businessUnit", query: { id: num } });
    },
    // 关于我们
    AboutUs(a) {
      console.log("关于我们", a);
      let num = null;
      switch (a) {
        case 1:
          num = "first";
          break;
        case 2:
          num = "second";
          break;
        case 3:
          num = "third";
          break;
      }
      this.is = num;
      this.$router.push({ path: "/aboutUs", query: { id: num } });
    },
    // 行业新闻
    Dynamic(a) {
      console.log("动态资讯", a);
      this.$router.push({ path: "/dynamicInformation" });
    },
    // 培训
    Training() {
      this.$router.push({ path: "/training" });
    },
    // 联系我们
    ContactUs(a) {
      console.log("联系我们", a);
      this.$router.push({ path: "/contactUs" });
    },
  },
  // watch: {
  //   $route(to, form) {
  //     console.log(111, to, form);
  //     switch (to.name) {
  //       case "home":
  //         console.log("home");
  //         break;
  //       case "AboutUs":
  //         console.log("AboutUs");
  //         this.$router.go({ path: "/aboutUs", query: { id: this.is } });
  //         break;
  //     }
  //   },
  // },
};
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  .content {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    max-width: 1200px;
    min-width: 900px;
    margin: auto;
    height: calc(100% - 60px);
    font-family: Microsoft YaHei;
    padding: 0 50px;
    .left {
      display: flex;
      justify-content: space-between;
      width: 50%;
      height: 100%;
      ul {
        list-style: none;
        // text-align: center;
        margin-top: 60px;
        padding-inline-start: 0px;
        li {
          margin-bottom: 10px;
          font-size: 14px;
          white-space: nowrap;
          cursor: pointer;
          color: #666;
        }
      }
      ul > li:nth-child(1) {
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        color: #333;
      }
    }
    .right {
      width: 50%;
      margin-left: 50px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .QRcode {
        display: flex;
        flex-direction: column;
        width: 150px;
        height: 160px;
        color: #333;
        div {
          text-align: center;
        }
        // img:hover {
        //   animation: rotation 0.5s linear;
        // }
        // @-webkit-keyframes rotation {
        //   from {
        //     -webkit-transform: rotate(0deg);
        //   }
        //   to {
        //     -webkit-transform: rotate(-360deg);
        //   }
        // }
      }
      .way {
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        justify-content: flex-end;
        height: 150px;
        margin-left: 25px;
        margin-top: 5px;
        color: #666;
        font-size: 14px;
        line-height: 32px;
        padding-bottom: 15px;
        p {
          text-indent: 2em;
        }
        .site {
          display: flex;
        }
      }
    }
  }

  .base {
    width: 100%;
    height: 60px;
    line-height: 60px;
    background-color: #eeeeee;
    color: #333;
    font-size: 16px;
    font-family: Microsoft YaHei;

    .deta {
      display: flex;
      justify-content: space-between;
      align-items: center;
      max-width: 1200px;
      min-width: 900px;
      margin: auto;
      padding: 0 50px;
      div:nth-child(1) {
        white-space: nowrap;
      }
      div:nth-child(2) {
        float: right;
      }
    }
  }
}
</style>
